import {
  FETCH_UNIVERSITIES,
  FETCH_UNIVERSITIES_SUCCESS,
  FETCH_UNIVERSITIES_FAIL
} from '../../config/constants/actionTypes';

export const fetchUniversities = payload => ({
  type: FETCH_UNIVERSITIES,
  payload,
});

export const fetchUniversitiesSuccess = payload => ({
  type: FETCH_UNIVERSITIES_SUCCESS,
  payload,
});

export const fetchUniversitiesFail = payload => ({
  type: FETCH_UNIVERSITIES_FAIL,
  payload,
});


// WEBPACK FOOTER //
// ./src/modules/universities/actions.js